module.exports = __webpack_public_path__ + "img/discord.b39c2aa4.svg";